import {
  computed,
  unref,
} from 'vue';

import {
  CLIENT_I18N_INSTANCE,
} from './_state.ts';
import {
  I18N_NAMESPACE,
} from './constants.ts';
import type {
  TSupportedLocale,
} from './messages.ts';

function joinKey(...parts: string[]) {
  return parts.filter(Boolean).join('.');
}

export function useLibraryI18n(componentScope?: string) {
  if (CLIENT_I18N_INSTANCE.instance === undefined) {
    throw new Error('The @qmulus/ui library was not registered with the app.');
  }
  const i18n = CLIENT_I18N_INSTANCE.instance;

  const base = componentScope
    ? joinKey(I18N_NAMESPACE, componentScope)
    : I18N_NAMESPACE;

  function scopedKey(key: string) {
    return joinKey(base, key);
  }

  function t(key: string, ...args: unknown[]): string {
    return i18n.global.t(scopedKey(key), ...args);
  }

  const locale = computed(() => unref(i18n.global.locale) as TSupportedLocale);

  return {
    t,
    te: (key: string) => i18n.global.te(scopedKey(key)),
    key: scopedKey,
    locale,
  };
}

export default useLibraryI18n;
